
import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue'
import Directr, { ContentType } from '@/services/directr'
import { useStore } from 'vuex'
import { CtInventoryLocation, CtStockItem, CtStockLedger, CtStorageLocation } from '@/models/interfaces/content-type'
import ChevronDownIcon from '@/components/Icons/ChevronDownIcon.vue'
// import { UUID } from '.yalc/@Protium/vue-ozone-utils/types'

export default defineComponent({
  name: 'WarehouseInformation',
  components: { ChevronDownIcon },
  props: {
    componentId: {
      type: String,
      required: true,
    }
  },

  setup (props) {
    const $store = useStore()
    const $directr: Directr = $store.getters['Services/Directr']

    const state = reactive({
      warehouses: null as Array<CtStorageLocation> | null,
      locations: null as Array<CtInventoryLocation> | null,
      ledger: null as Array<CtStockLedger> | null,
      stockCount: 0,
      componentLocations: {},
      activeWarehouse: {},
      expanded: false,
    })

    const getStorageLocations = async () => {
      state.locations = await $directr.get(ContentType.InventoryLocation, [{ field: 'stock_item', method: 'is', match: props.componentId }], { resolve: 1 })
        .then(({items}) => items) || []
      state.warehouses = state.locations?.map(l => l.storage_location as CtStorageLocation).filter(Boolean) || []
      state.ledger = !state.locations?.length ? [] : await $directr.get(ContentType.StockLedger, [{ field: 'id', method: 'is', match: (state.locations[0].stock_item as any)?.sys?.id }])
        .then(({items}) => items) || []

      return { warehouses: state.warehouses, locations: state.locations }
    }

    const matchStockToWarehouses = () => {
      if (!props.componentId || !state.warehouses || !state.locations) return
      state.componentLocations = (state.locations || [])
        .filter(location => (location.stock_item as CtStockItem)?.sys?.id === props.componentId)
        .reduce((byWarehouse, loc) => {
          if (!loc.storage_location) return byWarehouse
          const sl:any = loc.storage_location

          if (byWarehouse[sl.id || 'Unnamed'])  byWarehouse[sl.id || 'Unnamed'].push(loc)
          else byWarehouse[sl.id || 'Unnamed'] = [loc]

          return byWarehouse
        }, {})
    }

    const setActiveWarehouse = (warehouse?) => {
      if (Object.keys(state.activeWarehouse).length === 0 && Object.keys(state.componentLocations).length !== 0) {
        const firstKey = Object.keys(state.componentLocations)[0]
        state.activeWarehouse = { [firstKey]: state.componentLocations[firstKey] }
      } else if (warehouse) {
        state.activeWarehouse = { [warehouse]: { ...state.componentLocations[warehouse] } }
      }
      state.expanded = false
    }

    const calculateStockCount = () => {
      (state.ledger || []).forEach(ledger => {
        state.stockCount = state.stockCount + +ledger.count
      })
    }

    onMounted(() => {
      void getStorageLocations()
        .then(() => {
          void matchStockToWarehouses()
          void setActiveWarehouse()
          void calculateStockCount()
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    })

    return {
      ...toRefs(state),
      setActiveWarehouse,
    }
  }
})
